var map = {
	"./en/authForms.json": "e833",
	"./en/buttons.json": "6502",
	"./en/menu.json": "34de",
	"./en/pages.json": "fbdd",
	"./en/user.json": "a92a",
	"./ja/menu.json": "f6c6",
	"./ja/user.json": "3dfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a35b";